import React, { Component } from "react";
import FlexText from "../../flexText";
import Icon from "../../pageElements/icon";
import gutter from "../../config/vars";
const liStyle = {
  background: "rgb(167, 212, 238)",
  boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 4px 0px",
  borderRadius: "2px",
  border: "1px solid rgb(133, 167, 187)",
  fontFamily: "Oswald",
  fontSize: window.innerWidth > 600 ? "20px" : "13px",
  color: "#444444",
  letterSpacing: "0",
  lineHeight: "22px",
  textDecoration: "none",
  width: "100%",
  textTransform: "uppercase",
  padding: gutter,
  position: "absolute",
  left: "0px",
  minHeight: "65px",
  maxHeight: "65px"
};

class SelectBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      rotate: 0
    };
    this.handleClick = this.handleClick.bind(this);
  }

  renderOptions(stackTop) {
    if (this.state.open === false) {
      return this.props.links.map((link, i) => (
        <li
          tabIndex="0"
          key={i}
          value={link.url}
          style={{
            ...liStyle,
            fontSize: "10px",
            zIndex: 9 - i,
            top: stackTop + i * 3 + "px",
            transition: "1s"
          }}
        >
          {link.title}
        </li>
      ));
    } else {
      return this.props.links.map((link, i) => (
        <li
          tabIndex="0"
          key={i}
          style={{
            ...liStyle,
            fontSize: "24px",
            zIndex: 9,
            top: i * 65 + 65 + stackTop + "px",
            transition: "1s",
            margin: 0
          }}
        >
          <a tabIndex="0" href={link.url}>
            <Icon
              style={{ position: "absolute", top: 15, left: 5 }}
              className={link.title.substr(0, 3)}
              type={link.title.substr(0, 3)}
            />
            <FlexText
              color="#444"
              pert=".5"
              max="16"
              min="13"
              styles={{
                lineHeight: "18px",
                position: "absolute",
                top: "50%",
                transform: "translate(0, -50%)",
                paddingLeft: "32px"
              }}
            >
              {link.title}
            </FlexText>
          </a>
        </li>
      ));
    }
  }

  handleClick(event) {
    this.setState({
      open: !this.state.open,
      rotate: Math.abs(this.state.rotate - 1)
    });
  }

  render() {
    const stackTop = window.innerWidth > 599 ? -180 : -64;
    return (
      <div style={{}}>
        <ul
          id="boxLinks"
          style={{
            boxShadow: "0 2px 4px 0 rgba(0,0,0,0.15)",
            fontFamily: "Oswald",
            fontSize: "20px",
            color: "#444444",
            letterSpacing: "0",
            lineHeight: "22px",
            listStyle: " none",
            padding: "0",
            width: "80%",
            margin: "0 auto",
            boxSizing: "border-box",
            position: "relative"
          }}
        >
          <li>
            <button
              tabIndex="0"
              onClick={this.handleClick}
              style={{
                ...liStyle,
                fontSize: "16px",
                top: stackTop + "px",
                zIndex: "1000",
                padding: "24px 61px 24px 8px",
                cursor: "pointer"
              }}
            >
              Select An Area Of Study
              <Icon
                type="Arr"
                style={{
                  border: "0px solid #7594A6",
                  borderRightWidth: this.state.rotate + "px",
                  borderLeftWidth: Math.abs(this.state.rotate - 1) + "px",
                  paddingLeft: gutter,
                  position: "absolute",
                  bottom: "10px",
                  right: "0",
                  transform: "rotate(" + this.state.rotate * 180 + "deg)"
                }}
              />
            </button>
          </li>
          {this.renderOptions(stackTop - 5)}
        </ul>
      </div>
    );
  }
}
export default SelectBox;
